var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "41.000000pt",
    height: "46.000000pt",
    viewBox: "0 0 41.000000 46.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,46.000000) scale(0.100000,-0.100000)",
    fill: "inherit",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 380 c0 -38 -19 -60 -50 -60 l-30 0 0 -110 0 -111 118 3 117 3 0 145 0 145 -77 3 c-74 3 -78 2 -78 -18z m100 -125 c0 -13 -11 -15 -62 -13 -38 2 -63 8 -66 16 -3 9 14 12 62 12 53 0 66 -3 66 -15z m-2 -67 c-6 -18 -120 -18 -125 0 -4 9 13 12 62 12 49 0 66 -3 63 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 370 c-18 -20 -17 -20 8 -20 20 0 27 5 27 20 0 11 -4 20 -8 20 -5 0 -17 -9 -27 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 232 c0 -165 3 -162 -131 -162 -81 0 -99 -3 -99 -15 0 -13 21 -15 130 -15 l131 0 -3 157 c-2 114 -6 157 -15 161 -10 3 -13 -27 -13 -126z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImg);
export default __webpack_public_path__ + "static/media/fileImg.89067f5aaab1f2d853c786658ad775e0.svg";
export { ForwardRef as ReactComponent };